import { render, staticRenderFns } from "./PaymentReservationFormComponent.vue?vue&type=template&id=032b4a82&xmlns=true&"
import script from "./PaymentReservationFormComponent.vue?vue&type=script&lang=js&"
export * from "./PaymentReservationFormComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports